// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_jg","advertCardPhoto__image":"c-a_jh"};